import { Component, Inject, OnInit } from '@angular/core';
import { ConfigStorage, ENVIRONMENT, Link, LinkTokenService, StaticLink, TokenStorage, dateFormat, ServerTimeService } from '@scisys-uim/uim-common';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  title: string;
  eSalesLink: Link;
  fcItEmail: string;
  fcItSubject: string;
  fcItBody: string;
  appVersion: string;
  appVersionVisible: boolean;

  constructor(public configService: ConfigStorage, protected tokenStorage: TokenStorage, protected serverTimeService: ServerTimeService, @Inject(ENVIRONMENT) environment: any, linkTokenService: LinkTokenService) {
    this.fcItEmail = "operationsadmin@forestryengland.uk";
    this.fcItSubject = "eAssets";
    this.fcItBody = "";
    this.appVersion = environment.appVersion;
    this.appVersionVisible = !!environment.appVersionVisible;
  }

  ngOnInit() {
    this.configService.resolve().subscribe(config => {
      this.title = config.title;
    });
  }

  get formattedCurrentDateTime(): string {
    let serverTime = this.serverTimeService.getServerTime();
    return dateFormat(serverTime, 'dateTime');
  }

  get tokenExpiryAt(): Date {
    let expires = this.tokenStorage.getTokenExpiresDate();
    return expires
  }

  get tokenExpiryAtDisplay(): string {
    let expires = this.tokenExpiryAt;
    return dateFormat(expires, 'dateTime');
  }

  get tokenExpiryInDisplay(): string {
    return this.tokenStorage.getTokenExpiryTimeDisplay('-', ' (EXPIRED)');
  }

}
